import { render } from "./ReihenhausStep10.vue?vue&type=template&id=116207a8&scoped=true"
import script from "./ReihenhausStep10.vue?vue&type=script&lang=js"
export * from "./ReihenhausStep10.vue?vue&type=script&lang=js"

import "./ReihenhausStep10.vue?vue&type=style&index=0&id=116207a8&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116207a8"]])

export default __exports__